export const Settings = [
  {
    path: '/settings/:app_module_id',
    name: 'settings.index',
    component: () => import('@/pages/Settings/SettingsModule')
  },
  {
    path: '/settings/:app_module_id/notifications',
    name: 'settings.notifications',
    component: () => import('@/pages/Settings/SettingsNotifications')
  }
]
